<template>
  <div class="team">
    <header-group :heading="team.name" subheading="Oversigt over holdet"></header-group>
    <p class="text">{{{team.description}}}</p>

    <ul>
      <list-item v-for="item in items" size="small" :index="$index" v-link="item.link">
        {{item.title}}
      </list-item>
    </ul>
  </div>
</template>

<script>
import view from '../mixins/view'
import HeaderGroup from 'components/HeaderGroup'
import ListItem from 'components/ListItem'

// Gettes
import { activeTeam } from 'state/teams/getters'

// Actions
import { setActiveTeam } from 'state/teams/actions'

export default {
  name: 'Team',
  mixins: [view],
  components: {
    HeaderGroup, ListItem
  },
  vuex: {
    getters: {
      team: activeTeam
    },
    actions: {
      setActiveTeam
    }
  },
  data () {
    return {
      items: [
        {
          title: 'Sessions',
          link: {
            name: 'sessions'
          }
        },
        {
          title: 'Deltagere',
          link: {
            name: 'participants'
          }
        },
        {
          title: 'Evalueringer',
          link: {
            name: 'survey'
          }
        },
        {
          title: 'Noter',
          link: {
            name: 'notes'
          }
        }
      ]
    }
  },
  computed: {
    id () {
      return this.$route.params.team
    }
  },
  ready () {
    this.setActiveTeam(this.id)
  }
}
</script>

<style lang="scss" scoped>
.text {
  font-size: 3rem;
  font-style: normal;
}

/* this is the magic */
a {
  text-decoration:none;
  border-bottom: 2px solid blue;
  box-shadow: inset 0 -4px 0 blue;
  color: inherit;
  transition: all 0.1s cubic-bezier(.33,.66,.66,1);
}

a:hover {
  background: blue;
  color: white;
}
</style>



// WEBPACK FOOTER //
// Team.vue?9e85d86c